// Unified filter list - backend will determine what field to query
// filterType: 'category' | 'cuisine' | 'tag'
// Category/tag values: lowercase. Cuisine values: Title Case (canonical).
export const ALL_CATEGORIES = [
  { label: "🍽️ Meals", value: "food", filterType: "category" },
  { label: "🍹 Drinks", value: "drinks", filterType: "category" },
  { label: "🍰 Desserts", value: "dessert", filterType: "category" },
  { label: "🥗 Healthy", value: "healthy", filterType: "category" },

  { label: "🥡 Chinese", value: "Chinese", filterType: "cuisine" },
  { label: "🍣 Japanese", value: "Japanese", filterType: "cuisine" },
  { label: "🍜 Thai", value: "Thai", filterType: "cuisine" },
  { label: "🍛 Indian", value: "Indian", filterType: "cuisine" },
  { label: "🇲🇾 Local", value: "Local", filterType: "cuisine" },
  { label: "🍔 Western", value: "Western", filterType: "cuisine" },
  { label: "🍟 Fast Food", value: "Fast Food", filterType: "cuisine" },
  { label: "🏪 Convenience", value: "Convenience", filterType: "cuisine" },
  { label: "🍲 Korean", value: "Korean", filterType: "cuisine" },
  { label: "🍝 Italian", value: "Italian", filterType: "cuisine" },
  { label: "🍿 Snacks", value: "Snacks", filterType: "cuisine" },

  // { label: "🎃 Halloween", value: "halloween", filterType: "tag" },
  // { label: "🎄 Christmas", value: "christmas", filterType: "tag" },
  // { label: "🧧 CNY", value: "cny", filterType: "tag" },
  // { label: "1️⃣1️⃣ 11.11", value: "double_11", filterType: "tag" },
  // { label: "🎂 Birthday", value: "birthday", filterType: "tag" },
];

export const TIME_OF_DAY_OPTIONS = [
  { key: "all_day", label: "All" },
  { key: "breakfast", label: "Breakfast" },
  { key: "lunch", label: "Lunch" },
  { key: "dinner", label: "Dinner" },
];

export const DATE_OPTIONS = [
  { key: "today", label: "Today" },
  { key: "this_week", label: "This Week" },
];

export const SESSION_STORAGE_KEY = "deals_cache";
export const SCROLL_POSITION_KEY = "deals_scroll_position";

/** Initial visible rows per bucket / section before “Load more”. */
export const DEAL_LIST_SECTION_PAGE_SIZE = 20;

/** See `DEAL_LIST_BOTTOM_SCROLL_RESERVE` — px part only (safe-area added in calc). */
export const DEAL_LIST_BOTTOM_SCROLL_RESERVE_PX = 120;

/**
 * Bottom padding for scrollable deal (and matching) lists so the last rows and
 * “Load more” clear the fixed `DealsBrowseBottomToggle` pill
 * (`bottom: calc(28px + safe-area)` + ~48px control height) with comfortable gap.
 */
export const DEAL_LIST_BOTTOM_SCROLL_RESERVE = `calc(${DEAL_LIST_BOTTOM_SCROLL_RESERVE_PX}px + env(safe-area-inset-bottom, 0px))`;
